"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Asset Data Service API
 * ADS API Service is responsible for managing organization\'s assets
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rswarriors@arcticwolf.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExternalIpsToJSON = exports.ExternalIpsFromJSONTyped = exports.ExternalIpsFromJSON = exports.instanceOfExternalIps = void 0;
var ExternalIp_1 = require("./ExternalIp");
var ExternalIpsMetadata_1 = require("./ExternalIpsMetadata");
/**
 * Check if a given object implements the ExternalIps interface.
 */
function instanceOfExternalIps(value) {
    var isInstance = true;
    isInstance = isInstance && "metadata" in value;
    isInstance = isInstance && "externalIps" in value;
    return isInstance;
}
exports.instanceOfExternalIps = instanceOfExternalIps;
function ExternalIpsFromJSON(json) {
    return ExternalIpsFromJSONTyped(json, false);
}
exports.ExternalIpsFromJSON = ExternalIpsFromJSON;
function ExternalIpsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'metadata': (0, ExternalIpsMetadata_1.ExternalIpsMetadataFromJSON)(json['metadata']),
        'externalIps': (new Set(json['externalIps'].map(ExternalIp_1.ExternalIpFromJSON))),
    };
}
exports.ExternalIpsFromJSONTyped = ExternalIpsFromJSONTyped;
function ExternalIpsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'metadata': (0, ExternalIpsMetadata_1.ExternalIpsMetadataToJSON)(value.metadata),
        'externalIps': (Array.from(value.externalIps).map(ExternalIp_1.ExternalIpToJSON)),
    };
}
exports.ExternalIpsToJSON = ExternalIpsToJSON;
